import {
    List,
    ListItem,
    ListSubheader,
} from "@material-ui/core";
import React from "react";
import {CourseListItem} from "../../../Features/Planner/Views/CourseListItem";
import Semester from "../../Models/Semester";
import styled from "styled-components";
import Course from "../../Models/Course";

interface SemesterListItemProps {
    semester: Semester;
    onClick: (course: Course) => void;
    isCurrent: boolean;
}

const Container = styled(ListItem).attrs((props: any) => ({
    iscurrent: props.iscurrent
}))`
  background-color: ${(props: any) => props.iscurrent ? "rgba(4, 106, 56, 10%)" : "rgba(226, 225, 218, 35%)"};
`;

const ListContainer = styled(List)`
  height: auto;
  width: 100%;
  padding-left: 8px !important;
  padding-right: 8px !important;
`;

const SemesterListItem = (props: SemesterListItemProps) => {
    const {semester, onClick, isCurrent} = props;
    const {title, courses} = semester;
    const displayCourses = (courses: Course[]) =>
        courses.map((course: Course, index: number) =>
        <CourseListItem
            course={course}
            key={index}
            onClick={onClick}
        />);

    return (
            <Container divider iscurrent={isCurrent ? 1 : 0}>
                <ListContainer
                    subheader={
                        <ListSubheader disableSticky>
                            {title}
                        </ListSubheader>
                    }
                >
                    { displayCourses(courses) }
                </ListContainer>
            </Container>
    );
};

export default SemesterListItem;

